module.exports = __webpack_public_path__ + "media/images/guideline/H_05-b9da99dfd11d472103ffa32eafbd4b9f.jpg";